<template>
  <div class="home" :class="isMobile == 1 ? 'home-m' : ''">
    <swiper> </swiper>

    <div class="block_1_bg">
      <div class="block_1">
        <div class="item" v-for="(item, index) in block_1_list" :key="index">
          <img class="l" :src="require('@/assets/' + item.imgurl)" alt="" />
          <div class="r">
            <div>
              <span class="txt1">{{ item.txt1 }}</span>
              <span class="txt2">{{ item.txt2 }}</span>
            </div>
            <div class="txt3">{{ item.txt3 }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="all_bg">
      <div class="block_2_bg">
        <div class="block_2">
          <div class="l">
            <div>
              <span class="txt1">关于我们</span>
              <span class="txt2"> ABOUT US </span>
            </div>
            <div class="line"></div>

            <div class="txt3">
              <div>
                南京亿展盛途科技有限公司是国内领先的智慧会展门禁解决方案服务商。公司以南京为运营中心，专注于为会展行业提供一站式集成服务，核心业务涵盖智能登记系统、数字化展商管理系统及高性能门禁设备的研发与部署。
              </div>
              <div>
                凭借成熟的技术方案和稳定的产品性能，公司业务已成功辐射上海、深圳、广州、北京、成都、青岛等主要会展城市，深度服务各大展会项目，以技术驱动会展安全管理与流程效率的全面提升。
              </div>
            </div>
            <div
              class="common-btn1 button-view-more"
              @click="$router.replace('/guanyu')"
            >
              查看更多
            </div>
          </div>
          <!-- <div class="r">
            <img class="img1" src="../assets/005.png" alt="" />
            <img class="img2" src="../assets/006.png" alt="" />
          </div> -->
        </div>
        <div class="block_3">
          <div class="title-box">
            <div class="title-cn">产品和服务</div>
            <div class="line"></div>
          </div>

          <div class="cont">
            <img class="bg-img" src="../assets/bg2.png" alt="" />
            <div class="item">
              <img
                class="step-img"
                :class="{ active: currentProductIndex === 0 }"
                src="../assets/step1.png"
                alt=""
                @click="selectProduct(0)"
              />
              <div class="step-text">软件产品</div>
            </div>

            <div class="item">
              <img
                class="step-img"
                :class="{ active: currentProductIndex === 1 }"
                src="../assets/step2.png"
                alt=""
                @click="selectProduct(1)"
              />
              <div class="step-text">硬件产品</div>
            </div>
            <div class="item">
              <img
                class="step-img"
                :class="{ active: currentProductIndex === 2 }"
                src="../assets/step3.png"
                alt=""
                @click="selectProduct(2)"
              />
              <div class="step-text">呼叫中心</div>
            </div>
            <div class="item">
              <img
                class="step-img"
                :class="{ active: currentProductIndex === 3 }"
                src="../assets/step4.png"
                alt=""
                @click="selectProduct(3)"
              />
              <div class="step-text">证件硬刷制作</div>
            </div>
            <div class="item">
              <img
                class="step-img"
                :class="{ active: currentProductIndex === 4 }"
                src="../assets/step5.png"
                alt=""
                @click="selectProduct(4)"
              />
              <div class="step-text">人员服务</div>
            </div>
            <div class="item">
              <img
                class="step-img"
                :class="{ active: currentProductIndex === 5 }"
                src="../assets/step6.png"
                alt=""
                @click="selectProduct(5)"
              />
            </div>

            <div class="content-card">
              <div class="content-left">
                <div class="carousel-nav">
                  <div class="nav-btn nav-up" @click="prevProduct">
                    <i class="el-icon-arrow-up"></i>
                  </div>
                  <div class="nav-btn nav-down" @click="nextProduct">
                    <i class="el-icon-arrow-down"></i>
                  </div>
                </div>
                <div class="carousel-container">
                  <img
                    class="carousel-img"
                    :src="
                      require('@/assets/' +
                        product_list[currentProductIndex].img)
                    "
                  />
                  <!-- <img
                    v-for="(item, index) in product_list"
                    :key="index"
                    :src="require('@/assets/' + item.img)"
                    :alt="item.title"
                    :class="[
                      'carousel-img',
                      { active: currentProductIndex === index },
                    ]"
                  /> -->
                </div>
                <div class="carousel-container carousel-containe2"></div>
                <div class="carousel-container carousel-containe3"></div>
              </div>
              <div class="content-right">
                <transition name="fade" mode="out-in">
                  <div :key="currentProductIndex">
                    <div class="title-en">
                      {{ product_list[currentProductIndex].titleEn }}
                    </div>
                    <div class="title-cn">
                      {{ product_list[currentProductIndex].titleCn }}
                    </div>
                    <div class="category-list">
                      <div
                        class="category-item"
                        v-for="(category, index) in product_list[
                          currentProductIndex
                        ].categories"
                        :key="index"
                      >
                        <div class="category-title">{{ category.title }}</div>
                        <div class="category-desc">{{ category.desc }}</div>
                      </div>
                    </div>

                    <div
                      class="common-btn1 button-learn-more-bg"
                      @click="
                        $router.replace(product_list[currentProductIndex].route)
                      "
                    >
                      了解详情
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>

        <!-- 展商秀 -->
        <div class="block_6">
          <div class="l">
            <div class="l_box">
              <span class="txt1">展商秀来啦！</span>
              <span class="txt2">
                亿展盛途——展示、邀约、互动，您的专属定制“展商秀”正式上线
              </span>
            </div>
            <div class="txt3">
              <div class="txt3-item">
                <span class="item1">超强引流</span>
                <span class="item2"
                  >所有观众都能通过官方微信公众号进入展商秀~</span
                >
              </div>
              <div class="txt3-item">
                <span class="item1">极致展示</span>
                <span class="item2"
                  >全方位立体化展示贵司的企业信息、展位展品、现场活动等信息,
                  让观众提前"零距离"与您相约！</span
                >
              </div>
              <div class="txt3-item">
                <span class="item1">多维搜索</span>
                <span class="item2"
                  >通过公司名称、类别、展馆等多个分类，观众可以快速搜索到您！</span
                >
              </div>
            </div>
            <div
              class="common-btn1 button-learn-more-yellow"
              @click="
                linkto(
                  'https://zcygz.zcyit.cn/zsxh5/#/pages/seller/details?id=24&zsid=602'
                )
              "
            >
              了解详情
            </div>
          </div>
          <div class="r">
            <img class="img1" src="../assets/bg3.png" alt="" />
          </div>
        </div>
      </div>

      <!-- <div class="block_4_bg">
        <div class="block_4">
          <div class="title-box">
            <div class="title-cn">资讯中心</div>
            <div class="line"></div>
          </div>

          <div class="cont">
            <div class="r">
              <div
                class="item"
                v-for="(item, index) in zixun_list"
                :key="index"
                v-if="index > 0 && index < 4"
                @click="redirectToBaidu(item.url)"
              >
                <div class="item_l">
                  <img
                    class="img"
                    :src="require('@/assets/' + item.logo)"
                    alt=""
                  />
                </div>
                <div class="item_r">
                  <div class="title">{{ item.title }}</div>
                  <div class="jieshao">{{ item.details }}</div>
                  <div class="bott">
                    <div class="time">{{ item.date }}</div>
                    <div class="bott-r">
                      <span>详情</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="block_7_bg">
        <div class="block_7">
          <!-- 主标题区域 -->
          <div class="l">
            <div class="txt1">服务案例</div>
            <div class="txt2">SERVICE CASES</div>
          </div>

          <!-- 描述文字 -->
          <div class="txt3">
            全国服务超过30多个城市,年均服务过的展会和会议项目超100场,累计服务项目超过1000场。
          </div>

          <!-- 统计数据区域 -->
          <div class="r">
            <!-- 第一个统计：30+ 城市 -->
            <div class="stat-item">
              <div class="stat-icon city-icon">
                <img src="../assets/icon5.png" alt="" />
              </div>
              <div class="stat-number">30+</div>
            </div>

            <!-- 第二个统计：100+ 年均服务项目 -->
            <div class="stat-item">
              <div class="stat-icon city-icon">
                <img src="../assets/icon6.png" alt="" />
              </div>
              <div class="stat-content">
                <div class="stat-number">100+</div>
                <div class="stat-label">年均服务项目</div>
              </div>
            </div>

            <!-- 第三个统计：累计服务项目 -->
            <div class="stat-item">
              <div class="stat-icon city-icon">
                <img src="../assets/icon7.png" alt="" />
              </div>
              <div class="stat-label">累计服务项目</div>
            </div>
          </div>

          <!-- 背景装饰元素 -->
          <div class="bg-pattern"></div>
        </div>
      </div>

      <div class="block_5_bg">
        <div class="block_5">
          <div class="top">
            <div class="btn" @click="moveLeft">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div class="btn" @click="moveRight">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>

          <div class="bott">
            <div class="r">
              <div
                class="item"
                v-for="(item, index) in anli_list"
                :key="index"
                :style="{ transform: 'translateX(' + translateX + 'px)' }"
              >
                <img
                  class="img"
                  :src="require('@/assets/' + item.img0)"
                  alt=""
                />
                <div class="info">
                  <div class="title">{{ item.title }}</div>
                  <div class="show show-s">主办方：{{ item.zhuban }}</div>
                  <div class="show">面积：{{ item.mianji }}</div>
                  <div class="show show-s">展会时间：{{ item.date }}</div>
                  <div class="show show-detail">
                    <img src="../assets/detail.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import swiper from "@/components/swiper.vue";
import zixunlist from "../../zixun.json";
import anlilist from "../../anli2.json";
export default {
  name: "HomeView",
  components: {
    swiper,
  },
  data() {
    return {
      isMobile: false,
      // 在数据属性中存储 window 对象
      windowObj: window,
      block_1_list: [
        {
          imgurl: "icon1.png",
          txt1: "专注",
          txt2: "门禁服务",
          txt3: "专注会展行业信息技术服务及门禁管理服务商",
        },
        // {
        //   imgurl: "icon2.png",
        //   txt1: "五年以上",
        //   txt2: "团队成员",
        //   txt3: "亿展盛途项目经理均有五年以上行业经验，人均年服务展会项目20场",
        // },
        {
          imgurl: "icon3.png",
          txt1: "70%",
          txt2: "系统服务",
          txt3: "目前服务项目中有70%小程序开发服务、观众预登记系统、展商管理系统、观众邀约系统等",
        },
        {
          imgurl: "icon4.png",
          txt1: "100场",
          txt2: "现场服务",
          txt3: "年服务超100场服务中，其中现场接待服务占90%",
        },
      ],
      zixun_list: [],
      anli_list: [],
      translateX: 0,
      currentProductIndex: 0,
      product_list: [
        {
          img: "pro1.jpg",
          titleEn: "SOFTWARE PRODUCT",
          titleCn: "软件产品",
          route: "/ruanjian",
          categories: [
            {
              title: "观众",
              desc: "数据管理系统、登记系统、邀约排行系统",
            },
            {
              title: "展商",
              desc: "展商CRM管理系统、展商秀系统、展商补证系统",
            },
            {
              title: "在线售票系统",
              desc: "动漫售票类系统、车展售票类系统",
            },
          ],
        },
        {
          img: "pro2.jpg",
          titleEn: "HARDWARE PRODUCT",
          titleCn: "硬件产品",
          route: "/yingjian",
          categories: [
            {
              title: "硬件设备",
              desc: "门禁系统、闸机设备、智能终端",
            },
            {
              title: "技术支持",
              desc: "设备安装、系统调试、维护服务",
            },
          ],
        },
        {
          img: "pro3.png",
          titleEn: "CALL CENTER",
          titleCn: "呼叫中心",
          route: "/hujiao",
          categories: [
            {
              title: "服务内容",
              desc: "电话咨询、客户服务、技术支持",
            },
          ],
        },
        {
          img: "pro4.png",
          titleEn: "CERTIFICATE PRINTING",
          titleCn: "证件印刷制作",
          route: "/zhengjian",
          categories: [
            {
              title: "印刷服务",
              desc: "证件制作、标签印刷、个性化定制",
            },
          ],
        },
        {
          img: "pro5.png",
          titleEn: "PERSONNEL SERVICES",
          titleCn: "人员服务",
          route: "/renyuan",
          categories: [
            {
              title: "服务团队",
              desc: "专业服务人员、现场支持、项目管理",
            },
          ],
        },
        {
          img: "014_6.jpg",
          titleEn: "DATA ANALYSIS",
          titleCn: "数据分析",
          route: "/shuju",
          categories: [
            {
              title: "分析报告",
              desc: "数据统计、趋势分析、专业报告",
            },
          ],
        },
      ],
    };
  },
  created() {
    // this.$nextTick(()=>{
    // this.isMobile = localStorage.getItem("isMobile")
    // })
    this.zixun_list = zixunlist.list;
    this.anli_list = anlilist.list;
    console.log(zixunlist);
    if (this._isMobile()) {
      console.log("手机端");
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    redirectToBaidu(url) {
      // 使用 window.location.href 跳转到百度页面
      this.windowObj.open(url, "_blank");
    },
    moveLeft() {
      console.log("left====", this.translateX);
      let num = this.anli_list.length;
      console.log("num", (num - 3) * 378);
      if ((num - 3) * 378 > -this.translateX) {
        this.translateX -= 378;
      }
    },
    // 单开一个页面
    linkto(url) {
      window.open(url);
    },
    moveRight() {
      console.log(this.translateX);
      if (this.translateX != 0) {
        this.translateX += 378;
      }
    },
    prevProduct() {
      if (this.currentProductIndex > 0) {
        this.currentProductIndex--;
      } else {
        this.currentProductIndex = this.product_list.length - 1;
      }
    },
    nextProduct() {
      if (this.currentProductIndex < this.product_list.length - 1) {
        this.currentProductIndex++;
      } else {
        this.currentProductIndex = 0;
      }
    },
    selectProduct(index) {
      this.currentProductIndex = index;
    },
  },
};
</script>
<style scoped lang='less'>
.block_1_bg {
  width: 100%;
  // height: 317px;
  // background: linear-gradient(-90deg, #1A3994 0%, #4E5EAA 100%);
  background: #ffffff;

  .block_1 {
    width: 1440px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;

    .item {
      flex: 1;
      display: flex;
      padding: 40px 20px;

      .l {
        width: 80px;
        height: 80px;
        flex-shrink: 0;
        object-fit: contain;
        display: block;
        margin-right: 20px;
      }

      .r {
        box-sizing: border-box;

        .txt1 {
          font-size: 28px;
          // font-family: SourceHanSansSC-Heavy, SourceHanSansSC;
          font-weight: 800;
          color: #182851;
          margin-right: 10px;
        }

        .txt2 {
          font-size: 20px;
          // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
          font-weight: 500;
          color: #182851;
          margin: 15px 0;
        }

        .txt3 {
          font-size: 16px;
          // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
          font-weight: 400;
          color: #000;
          line-height: 1.6;
          margin-top: 8px;
        }
      }
    }
  }
}

.line {
  width: 200px;
  height: 6px;
  background: linear-gradient(to right, #182851, #d48d31);
  margin-bottom: 40px;
}
.all_bg {
  width: 100%;
  .block_2_bg {
    width: 100%;
    .block_2 {
      width: 1440px;
      margin: 0 auto;
      display: flex;
      background: url("../assets/bg1.png") no-repeat center top;
      background-size: 100%;
      padding: 70px 80px;
      box-sizing: border-box;
      
      .l {
        .txt1 {
          font-size: 30px;
          // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
          font-weight: 500;
          color: #323232;
          line-height: 66px;
        }

        .txt2 {
          font-size: 24px;
          // font-family: Arial-BoldMT, Arial;
          color: #6e6e6e;
          line-height: 68px;
          margin: 30px 0 50px 20px;
        }

        .txt3 {
          width: 45%;
          font-size: 14px;
          // font-family: SourceHanSansSC-Light, SourceHanSansSC;
          font-weight: 300;
          color: #000000;
          line-height: 1.8;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 8;
          overflow: hidden;
        }

        .img3 {
          cursor: pointer;
          margin: 50px 0;
        }

        .txt4 {
          font-size: 20px;
          // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
          font-weight: 400;
          color: #656565;
          line-height: 30px;
        }
      }

      .r {
        margin-left: 80px;
        position: relative;
        box-sizing: border-box;
        padding-right: 80px;

        .img1 {
          width: 594px;
          height: 796px;
          opacity: 1;
        }

        .img2 {
          top: 20%;
          right: 0;
          position: absolute;
          box-shadow: 5px 0px 46px 0px rgba(#1d3b95, 0.2);
        }
      }
    }

    .block_3 {
      width: 1440px;
      margin: 0 auto;
      position: relative;

      .cont {
        position: relative;
        width: 100%;
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 40px 20px;
        box-sizing: border-box;
        flex-wrap: wrap;
        .bg-img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 1;
        }

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          .step-img {
            position: relative;
            z-index: 2;
            width: auto;
            height: auto;
            max-width: 180px;
            max-height: 120px;
            margin: 10px 10px;
            cursor: pointer;
            border-radius: 10px;
            transition: all 0.3s ease;
            opacity: 0.7;

            &:hover {
              transform: scale(1.05);
              opacity: 1;
            }

            &.active {
              border-radius: 50px;
              opacity: 1;
              transform: scale(1.1);
              box-shadow: 0 4px 12px rgba(35, 48, 127, 0.3);
            }
          }

          .step-text {
            position: relative;
            z-index: 2;
          }
        }

        .content-card {
          position: relative;
          z-index: 2;
          width: 100%;
          display: flex;
          border-radius: 12px;
          overflow: hidden;
          min-height: 500px;
          padding: 0 30px;
          .content-left {
            width: 100%;
            flex: 2;
            position: relative;
            overflow: hidden;

            padding: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .carousel-nav {
              // position: absolute;
              // left: 20px;
              // top: 50%;
              // transform: translateY(-50%);
              z-index: 10;
              display: flex;
              flex-direction: column;
              margin-right: 50px;
              background: #f2f2f2;
              border-radius: 50px;
              .nav-btn {
                width: 50px;
                height: 50px;
                // background: rgba(255, 255, 255, 0.9);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.3s ease;
                color: #bbbbbb;
                // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

                &:hover {
                  background: rgba(255, 255, 255, 1);
                  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                  color: #31479d;
                }

                i {
                  font-size: 18px;
                  color: #31479d;
                }
              }
            }

            .carousel-container {
              position: relative;
              width: 600px;
              height: 340px;
              background: #f2f2f2;
              border-radius: 20px;
              padding: 20px;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
              z-index: 10;
              .carousel-img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                // opacity: 0;
                transition: opacity 0.5s ease;
                z-index: 4;
                &.active {
                  opacity: 1;
                  z-index: 3;
                }
              }
            }
            .carousel-containe2 {
              width: 400px;
              height: 260px;
              position: absolute;
              z-index: 2;

              right: 60px;
              border-radius: 30px;
            }
            .carousel-containe3 {
              width: 300px;
              height: 200px;
              position: absolute;
              z-index: 1;

              right: 40px;
              border-radius: 30px;
            }
          }

          .content-right {
            flex: 1;
            padding: 60px 50px;
            box-sizing: border-box;
            position: relative;
            display: flex;
            flex-direction: column;

            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              bottom: 0;
              width: 2px;
              // background: #d0d4e0;
            }

            .title-en {
              font-size: 18px;
              font-weight: 400;
              color: #65686c;
              margin-bottom: 15px;
            }

            .title-cn {
              font-size: 30px;
              font-weight: 500;
              color: #221714;
              margin-bottom: 30px;
            }

            .divider {
              width: 2px;
              height: 40px;
              background: #d0d4e0;
              margin-bottom: 40px;
            }

            .category-list {
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .category-item {
                margin-bottom: 20px;
                display: flex;
                align-items: center;

                &:last-child {
                  margin-bottom: 0;
                }

                .category-title {
                  font-size: 17px;
                  font-weight: 500;
                  color: #221714;
                  font-weight: bold;
                  margin-right: 20px;
                }

                .category-desc {
                  font-size: 15px;
                  font-weight: 400;
                  color: #65686c;
                  line-height: 1.6;
                }
              }
            }

            .btn-detail {
              width: 180px;
              height: 50px;
              background: #182851;
              border-radius: 25px;
              color: #ffffff;
              font-size: 18px;
              font-weight: 400;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: background 0.3s ease;
              margin-top: 30px;

              &:hover {
                background: #1a2560;
              }
            }
          }
        }
      }
    }

    // 内容切换动画
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.3s ease;
    }
    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }

    .block_6 {
      width: 1440px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      padding: 0 150px;
      box-sizing: border-box;
      background: #182851;
      margin-top: 75px;
      .l {
        padding: 30px 0;
        .l_box {
          display: flex;
          flex-direction: column;
        }
        .txt1 {
          font-size: 30px;
          // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
          font-weight: 500;
          color: #fff;
          line-height: 66px;
        }

        .txt2 {
          font-size: 17px;
          // font-family: Arial-BoldMT, Arial;
          color: #fff;
          margin-bottom: 30px;
        }

        .txt3 {
          font-size: 14px;
          // font-family: SourceHanSansSC-Light, SourceHanSansSC;
          font-weight: 300;
          color: #fff;
          line-height: 1.8;
          padding: 10px;
          box-sizing: border-box;
          // display: -webkit-box;
          // -webkit-box-orient: vertical;
          // -webkit-line-clamp: 8;
          // overflow: hidden;
          .txt3-item {
            display: flex;
            align-items: flex-start;
            .item1 {
              width: 80px;
              font-size: 16px;
              font-weight: bold;
            }
            .item2 {
              flex: 1;
              font-size: 14px;
              line-height: 2;
            }
          }
        }

        .img3 {
          cursor: pointer;
          margin-top: 30px;
          margin-bottom: 20px;
        }

        .txt4 {
          font-size: 20px;
          // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
          font-weight: 400;
          color: #656565;
          line-height: 30px;
        }
      }

      .r {
        margin-left: 80px;
        position: relative;
        .img1 {
          width: 480px;
          height: auto;
        }
      }
    }
  }
}

.block_4_bg {
  width: 100%;
  padding-bottom: 96px;

  .block_4 {
    width: 1440px;
    margin: 0 auto;
    margin-top: 30px;
    .cont {
      display: flex;

      .l {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .item {
          box-sizing: border-box;
          background: #ffffff;
          border-bottom: 2px solid #ffffff;
          padding: 30px;

          .title {
            font-size: 28px;
            // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
            font-weight: 500;
            color: #2f2f2f;
            margin-bottom: 15px;
            text-align: center;
          }

          .jieshao {
            font-size: 20px;
            // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
            font-weight: 400;
            color: #5f5f5f;
            line-height: 36px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }

      .r {
        .item {
          box-sizing: border-box;
          background: #ffffff;
          padding: 30px;
          margin-bottom: 20px;
          border-bottom: 2px solid #ffffff;
          display: flex;
          align-items: center;
          .item_l {
            width: 300px;
            margin-right: 20px;
            .img {
              width: 100%;
            }
          }
          .item_r {
            flex: 1;
            .title {
              font-size: 28px;
              // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
              font-weight: 500;
              color: #2f2f2f;
            }

            .jieshao {
              font-size: 20px;
              // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
              font-weight: 400;
              min-height: 70px;
              color: #5f5f5f;
              line-height: 36px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin: 15px 0 10px;
            }

            .bott {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .time {
                font-size: 18px;
                // font-family: MicrosoftYaHei;
                color: #007cbf;
              }

              .bott-r {
                display: flex;
                align-items: center;
                font-size: 18px;
                // font-family: MicrosoftYaHei;
                color: #007cbf;
              }
            }
          }
        }

        .item:nth-last-child(1) {
          margin-bottom: 0;
        }
      }

      .item:hover {
        border-bottom: 2px solid #3b4f9f;

        .title {
          color: #3b4f9f;
        }

        .bott-r {
          color: #3b4f9f;
        }
      }
    }
  }
}
.block_7_bg {
  width: 100%;
  padding-bottom: 96px;

  .block_7 {
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding: 50px 150px;
    box-sizing: border-box;
    background: url("../assets/bg4.png") no-repeat center top;
    background-size: 100% 100%;
    .l {
      display: flex;
      align-items: center;
      .txt1 {
        font-size: 26px;
        // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
        font-weight: 500;
        color: #fff;
        margin-right: 40px;
      }

      .txt2 {
        font-size: 26px;

        // font-family: Arial-BoldMT, Arial;
        color: #fff;
      }

      .txt4 {
        font-size: 20px;
        // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        font-weight: 400;
        color: #656565;
        line-height: 30px;
      }
    }
    .txt3 {
      font-size: 16px;
      // font-family: SourceHanSansSC-Light, SourceHanSansSC;
      font-weight: 300;
      color: #fff;
      line-height: 1.8;
      box-sizing: border-box;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 8;
      // overflow: hidden;
      margin: 10px 0 40px;
    }
    .r {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, auto);
      grid-gap: 0px;
      justify-content: space-between;
      .stat-item {
        display: flex;
        align-items: center;
        .stat-icon {
          width: 60px;
          height: 60px;
          flex-shrink: 0;
          margin-right: 20px;
          .city-icon {
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .stat-content {
          display: flex;
          align-items: center;
        }
        .stat-number {
          font-size: 36px;
          // font-family: SourceHanSansSC-Bold, SourceHanSansSC;
          font-weight: bold;
          color: #fff;
          margin-right: 20px;
        }
        .stat-label {
          font-size: 22px;
          // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
          font-weight: 400;
          color: #fff;
        }
      }
      .img1 {
        width: 480px;
        height: auto;
      }
    }
  }
}

.block_5_bg {
  width: 100%;
  padding: 0 0 96px 0;

  .block_5 {
    width: 1440px;
    margin: 0 auto;
    position: relative;

    .top {
      width: 1700px;
      display: flex;
      justify-content: space-between;
      margin-left: -130px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      .btn {
        width: 57px;
        height: 57px;

        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        margin: 0 0 30px 15px;
        background: #ffffff;
        color: #a0a0a0;
        border-radius: 50%;
      }
    }

    .bott {
      display: flex;

      .r {
        flex: 1;
        display: flex;
        overflow-y: hidden;

        .item {
          width: 460px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          margin-left: 58px;
          box-sizing: border-box;
          transition: transform 0.5s ease;
          background: #fff;
          cursor: pointer;
          .img {
            width: 452px;
            height: 244px;
            object-fit: cover;
          }

          .info {
            // background: #c77373;
            box-sizing: border-box;
            padding: 25px 20px;
            transition-property: margin;
            transition-duration: 0.5s;

            .title {
              font-size: 22px;
              // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
              font-weight: 400;
              color: #65686c;
              margin-bottom: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-weight: bold;
            }

            .show {
              font-size: 18px;
              // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
              font-weight: 400;
              color: #65686c;
              line-height: 30px;
            }
            .show-detail {
              color: #1064f1;
              margin-top: 15px;
            }
            // .show-s {
            //   display: none;
            // }
          }
        }

        .item:nth-child(1) {
          margin-left: 0;
        }

        // .item:hover {
        //   .info {
        //     margin-top: -60px;
        //     background: #3b4f9f;
        //     position: relative;
        //     z-index: 5;

        //     .title {
        //       color: #fff;
        //     }

        //     .show {
        //       color: #fff;
        //     }

        //     .show-s {
        //       display: block;
        //     }
        //   }
        // }
      }
    }
  }
}

.title-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;

  .title-en {
    font-size: 28px;
    // font-family: DIN-Bold, DIN;
    font-weight: bold;
    color: #afb7bf;
    margin-bottom: 30px;
  }

  .title-cn {
    display: flex;
    align-items: center;
    font-size: 30px;
    // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
    font-weight: 500;
    color: #221714;
    margin-bottom: 20px;

    span {
      margin: 0 20px;
      width: 25px;
      height: 1px;
      background: #afb7bf;
    }
  }
}
</style>
<style scoped lang="less">
.home-m {
  .block_1 {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0px;
    .item {
      padding: 20px;
      .l {
        margin-right: 5px;
      }
      .r {
        box-sizing: border-box;
        padding: 20px 20px;

        .txt1 {
          font-size: 30px;
        }

        .txt2 {
          font-size: 20px;
          margin: 5px 0;
        }
      }
    }
  }

  .block_2 {
    width: 100% !important;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0 50px;

    .r {
      margin-left: 0px;
      margin-top: 50px;
    }
  }

  .block_3 {
    width: 100% !important;
    box-sizing: border-box;
    padding: 0 20px;

    .cont {
      padding: 20px 0;

      .step-img {
        max-width: 120px;
        margin: 8px 5px;
        border-radius: 8px;
      }

      .content-card {
        flex-direction: column;
        margin-top: 30px;
        min-height: auto;

        .content-left {
          width: 100%;
          min-height: 300px;

          .carousel-nav {
            left: 10px;

            .nav-btn {
              width: 35px;
              height: 35px;

              i {
                font-size: 16px;
              }
            }
          }

          .carousel-container {
            min-height: 300px;
          }
        }

        .content-right {
          width: 100%;
          padding: 40px 30px;

          .title-en {
            font-size: 16px;
            margin-bottom: 10px;
          }

          .title-cn {
            font-size: 28px;
            margin-bottom: 20px;
          }

          .divider {
            height: 30px;
            margin-bottom: 30px;
          }

          .category-list {
            .category-item {
              margin-bottom: 25px;

              .category-title {
                font-size: 20px;
                margin-bottom: 10px;
              }

              .category-desc {
                font-size: 14px;
              }
            }
          }

          .btn-detail {
            width: 160px;
            height: 45px;
            font-size: 14px;
            margin-top: 20px;
          }
        }
      }
    }
  }

  .block_4 {
    width: 100% !important;
    box-sizing: border-box;
    padding: 0 50px;

    .cont {
      flex-direction: column;

      .l {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .item {
          margin-top: 30px;
        }
      }

      .r {
        margin-left: 0px;

        .item {
          margin-bottom: 0px;
          margin-top: 30px;
        }
      }
    }
  }

  .block_5 {
    width: 100% !important;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 50px;

    .top {
      display: none;
    }

    .bott {
      flex-direction: column;

      .l {
        width: 100%;
        margin-bottom: 30px;
      }
    }
  }
  .block_6 {
    width: 100% !important;
    flex-direction: column;
  }
}

/* 第一个按钮：查看更多（白色背景，深色边框） */
.button-view-more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border: 1px solid #182851;
  border-radius: 50px;
  color: #182851;
  font-size: 16px;
  cursor: pointer;
  margin-top: 40px;
  &::after {
    content: ">";
    margin-left: 8px;
    font-weight: bold;
  }
}

/* 第二个按钮：了解详情（深蓝色背景） */
.common-btn1 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border-radius: 50px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 40px;
  &::after {
    content: ">";
    margin-left: 8px;
    font-weight: bold;
  }
}
.button-learn-more {
  background-color: #182851;
  &::after {
    color: #ffffff;
  }
}
.button-learn-more-bg {
  background: #182851;
  color: #ffffff;
  &::after {
    color: #ffffff;
  }
}

.button-learn-more-yellow {
  background-color: #d18624;
  color: #ffffff;
  &::after {
    color: #ffffff;
  }
}
.button-learn-more-white {
  color: #ffffff;
  &::after {
    color: #ffffff;
  }
}
</style>